import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node
};
